import { Component, Input } from '@angular/core';

@Component({
  selector: 'dt-table-layout',
  templateUrl: './table-layout.component.html',
  styleUrls: ['./table-layout.component.scss'],
  standalone: false,
})
export class TableLayoutComponent {
  @Input() isLoading = false;
}
